import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const BenefitBox = styled(Box)(({ theme }) => ({
  padding: '32px',
  borderRadius: '20px',
  background: theme.palette.mode === 'dark'
    ? 'rgba(30, 41, 59, 0.6)'
    : 'rgba(255, 255, 255, 0.9)',
  backdropFilter: 'blur(20px)',
  border: `2px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)'}`,
  transition: 'all 0.4s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.palette.mode === 'dark'
      ? '0 12px 32px rgba(16, 185, 129, 0.2)'
      : '0 12px 32px rgba(37, 99, 235, 0.15)',
  },
}));

interface ProductBenefitCardProps {
  title: string;
  description: string;
}

export default function ProductBenefitCard({ title, description }: ProductBenefitCardProps) {
  return (
    <BenefitBox>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        <CheckCircleIcon 
          sx={{ 
            fontSize: 32,
            color: (theme) => theme.palette.mode === 'dark' 
              ? theme.palette.secondary.light 
              : theme.palette.primary.main,
            flexShrink: 0,
          }} 
        />
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              mb: 1,
              fontSize: '1.25rem',
              background: (theme) => `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ lineHeight: 1.7 }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </BenefitBox>
  );
}